import PopupDom from './Popup';
import { wrap, wrapFC } from '../Overlay/Wrap';
const popup = wrap(PopupDom);
const Popup = wrapFC(PopupDom);
Object.assign(Popup, {
    popup,
});
export default Popup;
